export const CHECKOUT_URL = 'https://oclusion-en.impultienda.ar/checkout/'

export function formatClock(totalSeconds: number): string[] {
  const safe = Math.max(0, totalSeconds)
  const hours = Math.floor(safe / 3600)
  const minutes = Math.floor((safe % 3600) / 60)
  const seconds = safe % 60
  return [hours, minutes, seconds].map((unit) => String(unit).padStart(2, '0'))
}
